<template>
    <div class="productHost">
        <div class="tabBar">
            <div class="tabBarCon">
                <div v-if="ComparisonData" class="tabItem">
                    <a href="#ProductComparison">
                        
                    </a>
                </div>
                <div v-if="functionData" class="tabItem">
                    <a href="#GeneralFunction">
                        
                    </a>
                </div>
                <div v-if="productsData" class="tabItem">
                    <a href="#CompatibleProducts">
                       
                    </a>
                </div>
            </div>
        </div>
        <div v-if="ComparisonData" class="comparison" id="ProductComparison">
            <div class="contentTitle">
               
            </div>
            <div class="comparisonTop">
                <div class="smTitle">{{ ComparisonData.list[0].moduleTitle }}</div>
                <el-carousel ref="comparisonTopCarousel" :autoplay="false" indicator-position="none" trigger="click"
                    height="700px">
                    <el-carousel-item v-for="item in ComparisonData.list[0].list" :key="item.id">
                        <div class="carouselItem">
                            <div class="topImag">
                                <img :src="item.cover" alt="" />
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div class="comparisonTab">
                    <div @click="comparisonBannerChange(index)"
                        :class="index == comparisonBannerIndex ? 'activeItem' : ''"
                        v-for="(item, index) in ComparisonData.list[0].list" class="item">{{ item.title }}</div>
                </div>
            </div>
            <div v-for="item in ComparisonData.list[1].list" :key="item.id" class="comparisonContent">
                <div class="conTitle">
                    {{ item.title }}
                </div>
                <div class="contentFlex">
                    <div v-for="item2 in item.product_list" :key="item2.id" class="conItem">
                        <div class="imgWrap">
                            <div class="imgText">{{ item2.desc }}</div>
                            <img :src="item2.cover" alt="" />
                        </div>
                        <div class="footText">{{ item2.title }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="functionData" class="function" id="GeneralFunction">
            <div class="funTitle">
                
            </div>

            <div class="funItem">
                <div class="itemTitle">HD Video Processor</div>
                <div class="maxBnner">
                    <img src="@/assets/index/panda-bear.png" alt="" />
                </div>

                <div class="scorllBanner">
                    <div class="headBox">
                        <div class="headLeft">
                            <div @click="currentIndex = index" :class="index == currentIndex ? 'activeLine' : ''"
                                v-for="(item, index) in 10" :key="item" class="line">
                            </div>
                        </div>
                        <div class="rightBtn">
                            <div @click="currentIndex -= 1" class="bannerBtn">
                                <img src="@/assets/index/bannerBtn.png" alt="" />
                            </div>
                            <div @click="currentIndex += 1" class="bannerBtn bannerBtnRight">
                                <img src="@/assets/index/bannerBtn.png" alt="" />
                            </div>
                        </div>
                    </div>
                    {{ scorllBannerWidth }}
                    <div :style="{ width: `${scorllBannerWidth}px`, transform: `translate(${scorllBannerLeft}px , 0)` }"
                        class="bannerBox">
                        <div :style="{ transform: `translate(${bannerTranslateX} , 0)`, }" class="bannerList">
                            <div v-for="item in 10" :key="item" class="bannerItem">
                                <img src="@/assets/index/panda-bear.png" alt="" />
                                <div class="bannerName">USB storage</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="funItem">
                <div class="itemTitle">Widely Used</div>
                <div class="twoImageCom">
                    <div class="twoImageBox">
                        <div class="imagOne">
                            <div class="title">Flexible Endoscopy</div>
                            <img class="imag" src="@/assets/index/panda-bear.png" alt="" />
                        </div>
                        <div class="imagOne">
                            <div class="title">Flexible Endoscopy</div>
                            <img class="imag" src="@/assets/index/panda-bear.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="bottomText">Compatible with both flexible and rigid endoscopes</div>
            </div>

            <div class="funItem">
                <div class="itemTitle">Full HD Imaging</div>
                <div class="itemImg">
                    <img src="@/assets//index/panda-bear.png" alt="" />
                </div>
            </div>

            <div class="funItem">
                <div class="itemTitle">Downloads</div>
                <div class="DownFlex">
                    <div :key="item" v-for="item in 4" class="DownItem">
                        <img class="topImage" src="@/assets//index/panda-bear.png" alt="" />
                        <div class="name1">OR-160 </div>
                        <div class="name2">All-in-one Vet Endoscopy System</div>
                        <div class="fileInfo">
                            <div class="info">
                                <span class="name">Page :</span>
                                <span class="val">12</span>
                            </div>
                            <div class="info">
                                <span class="name">File Size :</span>
                                <span class="val">3 MB</span>
                            </div>
                        </div>
                        <div class="downBtn">Downloads</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="productsData" class="products" id="CompatibleProducts">
            <div class="productsTitle"></div>
            <div v-for="item in productsData.list" :key="item.id" class="productItem">
                <div class="itemTitle">{{ item.title }}</div>
                <div class="listBox">
                    <div v-for="item2 in item.product_list" :key="item2.id" class="listItem">
                        <img class="listImag" :src="item2.cover" alt="" />
                        <div class="footName">{{ item2.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        navList: {
            type: Array,
            default: (() => []),
        },
        content: {
            type: Array,
            default: (() => []),
        },
    },
    computed: {
        ComparisonData() {
            return this.content.find(el => el.moduleTitle == 'Product Comparison' && el.is_show == 1)
        },
        functionData() {
            return this.content.find(el => el.moduleTitle == 'General Function' && el.is_show == 1)
        },
        productsData() {
            return this.content.find(el => el.moduleTitle == 'Compatible Products' && el.is_show == 1)
        },
        bannerTranslateX() {
            return `-${this.currentIndex * (585 + 30)}px`
        },
    },
    data() {
        return {
            comparisonBannerIndex: 0,

            currentIndex: 0,
            scorllBannerWidth: 1540,
            scorllBannerLeft: 360,
        }
    },
    created() {
        let maxWidth = window.innerWidth
        let scorllBannerLeft = (maxWidth - 1200) / 2
        this.scorllBannerLeft = scorllBannerLeft
        this.scorllBannerWidth = maxWidth - scorllBannerLeft - 20
    },
    mounted() {

    },
    methods: {
        comparisonBannerChange(i) {
            this.$refs.comparisonTopCarousel.setActiveItem(i)
            this.comparisonBannerIndex = i
        },
    }
}
</script>

<style scoped lang="scss">
.productHost {
    background: #fff;

    .tabBar {

        border-bottom: 1px solid #000000;

        .tabBarCon {
            width: 1200px;
            margin: auto;
            display: flex;
            align-items: center;
            margin-top: 100px;

            .tabItem {
                margin-right: 100px;
                height: 60px;
                line-height: 60px;
                cursor: pointer;

                a {
                    font-weight: 300;
                    font-size: 22px;
                    color: #000000;
                    text-decoration: none;
                }
            }
        }

    }

    .comparison {
        width: 1200px;
        margin: auto;
        margin-top: 100px;

        .contentTitle {
            font-weight: bold;
            font-size: 48px;
            color: #000000;
            line-height: 50px;
            padding-bottom: 16px;
            border-bottom: 1px solid #000000;
        }

        .comparisonTop {
            margin-top: 40px;

            .smTitle {
                font-size: 40px;
                color: #000000;
                line-height: 40px;
                margin-bottom: 38px;
            }

            .topImag {

                img {
                    width: 1200px;
                    height: 700px;
                    object-fit: cover;
                }
            }

            .comparisonTab {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;

                .item {
                    width: 200px;
                    padding: 18px 0;
                    color: #D8D8D8;
                    border-bottom: 1px solid #D8D8D8;
                    text-align: center;
                    cursor: pointer;
                }

                .activeItem {
                    color: #000;
                    border-bottom: 1px solid #000;
                }
            }
        }

        .comparisonContent {
            margin-top: 100px;

            .conTitle {
                font-size: 40px;
                color: #000000;
                line-height: 40px;
            }

            .contentFlex {
                margin-top: 48px;
                display: flex;
                flex-wrap: wrap;
                gap: 30px;
                margin-bottom: 100px;

                .conItem {
                    width: 585px;

                    .imgWrap {
                        width: 100%;
                        position: relative;

                        .imgText {
                            width: 100%;
                            position: absolute;
                            left: 0;
                            top: 47px;
                            font-size: 18px;
                            color: #231815;
                            text-align: center;
                        }

                        img {
                            width: 100%;
                            height: 700px;
                            object-fit: cover;
                            display: block;
                        }
                    }

                    .footText {
                        margin-top: 40px;
                        font-size: 21px;
                        color: #000000;
                    }
                }
            }
        }
    }

    .function {
        .funTitle {
            width: 1200px;
            margin: auto;
            font-weight: bold;
            font-size: 50px;
            color: #000000;
            padding-bottom: 20px;
            border-bottom: 1px solid #000000;
        }

        .funItem {
            margin-top: 46px;

            .itemTitle {
                font-weight: 500;
                font-size: 40px;
                color: #000000;
                width: 1200px;
                margin: auto;
            }

            .maxBnner {
                width: 100%;
                height: 700px;
                margin-top: 40px;

                img {
                    width: 100%;
                    height: 700px;
                    object-fit: cover;
                    display: block;
                }
            }

            .itemImg {
                width: 100%;
                margin-top: 36px;

                img {
                    width: 1200px;
                    height: 700px;
                    object-fit: cover;
                    margin: auto;
                    display: block;
                }
            }

            .DownFlex {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                width: 1200px;
                margin: auto;
                margin-top: 46px;
                gap: 48px;

                .DownItem {
                    width: 260px;

                    .topImage {
                        width: 100%;
                        height: 350px;
                        object-fit: cover;
                        display: block;
                    }

                    .name1 {
                        margin-top: 36px;
                        font-size: 21px;
                        font-weight: bold;
                    }

                    .name2 {
                        font-size: 21px;
                    }

                    .fileInfo {
                        display: flex;
                        justify-content: space-between;
                        margin-top: 28px;

                        .info {
                            font-size: 21px;

                            .name {
                                font-weight: bold;
                            }

                            .val {}
                        }
                    }

                    .downBtn {
                        margin-top: 27px;
                        font-size: 21px;
                        color: #0083FF;
                        line-height: 30px;
                        cursor: pointer;
                    }
                }
            }
        }

    }

    .products {

        width: 1200px;
        margin: auto;
        margin-top: 100px;

        .productsTitle {
            font-size: 50px;
            color: #000000;
            font-weight: bold;
            padding-bottom: 15px;
            border-bottom: 1px solid #000000;
        }

        .productItem {
            margin-top: 45px;

            .itemTitle {
                font-weight: 500;
                font-size: 40px;
                color: #000000;
                line-height: 42px;
            }

            .listBox {
                display: flex;
                flex-wrap: wrap;
                margin-top: 39px;
                gap: 20px;

                .listItem {
                    width: 285px;
                    margin-bottom: 48px;

                    .listImag {
                        width: 285px;
                        height: 224px;
                        display: block;
                        object-fit: cover;
                    }

                    .footName {
                        margin-top: 19px;
                        font-weight: 500;
                        font-size: 21px;
                        line-height: 21px;
                        color: #000000;
                    }
                }
            }
        }
    }

    .scorllBanner {
        margin-top: 40px;

        .headBox {
            display: flex;
            justify-content: space-between;
            width: 1200px;
            margin: auto;

            .headLeft {
                display: flex;
                align-items: center;

                .line {
                    width: 36px;
                    height: 2px;
                    background: #B2B2B2;
                    border-radius: 1px;
                    margin-right: 10px;
                    cursor: pointer;
                }

                .activeLine {
                    background: #000000;
                }
            }

            .rightBtn {
                display: flex;

                .bannerBtn {
                    width: 40px;
                    height: 40px;
                    margin-left: 10px;
                    cursor: pointer;

                    img {
                        width: 40px;
                        height: 40px;
                        display: block;
                    }
                }

                .bannerBtnRight {
                    transform: rotate(180deg);
                }
            }
        }

        .bannerBox {
            overflow: hidden;
            margin-top: 30px;

            .bannerList {
                display: flex;
                flex-wrap: nowrap;
                transition: all 0.3s;

                .bannerItem {
                    margin-right: 30px;
                    width: 585px;

                    img {
                        width: 585px;
                        height: 600px;
                        display: block;
                        object-fit: cover;
                    }

                    .bannerName {
                        font-weight: 500;
                        font-size: 21px;
                        color: #000000;
                        line-height: 28px;
                        margin-top: 40px;
                    }
                }
            }
        }
    }
}

.twoImageCom {
    background: #F7F7F7;
    margin-top: 38px;

    .twoImageBox {
        width: 1200px;
        margin: auto;
        display: flex;

        .imagOne {
            width: 50%;
            position: relative;

            .title {
                font-weight: 500;
                font-size: 18px;
                color: #231815;
            }

            &:nth-child(1) {
                .title {
                    position: absolute;
                    right: 46px;
                    top: 48px;
                }
            }

            &:nth-child(2) {
                .title {
                    position: absolute;
                    left: 46px;
                    top: 48px;
                }
            }

            .imag {
                width: 100%;
                height: 700px;
                object-fit: cover;
                display: block;
            }
        }
    }
}

.bottomText {
    width: 1200px;
    margin: auto;
    margin-top: 40px;
    font-weight: 500;
    font-size: 21px;
    color: #000000;
}

::v-deep .comparisonTop {
    .el-carousel__arrow--left {
        display: none !important;
    }

    .el-carousel__arrow--right {
        display: none !important;
    }
}

@media screen and (max-width:1200px) {}
</style>